import { Box } from '@fluentui/react-northstar';
import { useTabSettings } from 'components/App/TabSettings';
import { ClickHandler } from 'components/Table/Actions';
import { TableRowData } from 'components/Table/Table';
import { joinPath } from 'utils';

export function OpenInWorkZone({ row, label, clickHandler }: { row: TableRowData; label: string; clickHandler: ClickHandler | undefined }) {

	const { server } = useTabSettings();

	if(clickHandler){
		clickHandler.clickAction = () => window.open(joinPath(server, 'app/client/#/Records', String(row.id)), '_blank');
	}

	return (
		<Box>{label}</Box>
	);
}
